<!--
* @date 2025-04-16 15:37:26
* @version V1.0.0
!-->
<template>
  <div id="index" class="index">
    <!-- cookie声明 -->
    <div class="cookieDiv" v-if="cookieDivOr">
      <p 
        >{{$t('cookie.t1')}}
          <span
          href="#"
          @click="handleXy"
          >{{$t('privacyAgreement.title')}}</span>
        {{$t('cookie.t2')}}</p
      >
      <div class="aDiv">
        <div class="js" @click="closeDiv">{{$t('cookie.jsBtn')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUuid,
  acceptUpdateUuid
} from '@/api/user'
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "index",
  data() {
    return {
      cookieDivOr: false,
    };
  },
  created() {
    // 实例被创建之后执行代码
    this.checkCookie()
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
    handleXy(){
      this.$router.push({
        path: '/privacyAgreement',
      })
    },
    // cookie
    getCookie: function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        // console.log(c, "c");
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
      // console.log(document.cookie);
    },
    clearCookie: function () {
      this.setCookie("allow_cookie", "", -1000); //设置天数
    },
    checkCookie: function () {
      var user = this.getCookie("allow_cookie");
      if (user != "") {
        this.cookieDivOr = false;
      } else {
        this.cookieDivOr = true;
      }
      var uuid = this.getCookie("cookie_uuid")
      if(uuid){
        if(this.$store.state.login.isLogin){
          acceptUpdateUuid({uuid: uuid}).then(res => {
            if (res.code == 0){
              
            }
          })
        }
      }
      
    },
    closeDiv() {
      getUuid().then(res => {
        if (res.code == 0){
          let uuid = res.data.id
          this.setCookie("cookie_uuid", uuid, 1000); //设置天数
          if(this.$store.state.login.isLogin){
            acceptUpdateUuid({uuid: uuid}).then(res => {
              if (res.code == 0){
                
              }
            })
          }
        }
      })
      this.setCookie("allow_cookie", "true", 1000); //设置天数
      this.cookieDivOr = false;
    },
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang="less">
.cookieDiv {
  width: calc(100% - 40px);
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  bottom: 0px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 10px 20px;
}
.cookieDiv p {
  color: #f0f3fb;
  font-size: 14px;
}
.cookieDiv span {
  color: red;
  cursor: pointer;
}
.aDiv{
  display: flex;
  align-items: center;
  width: 20%;
  justify-content: flex-end;
  margin-left: 10px;
  .js{
    color: #f0f3fb;
    font-size: 14px;
    border: 1px solid #F7F8FA;
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;
    word-break: keep-all;
    white-space: nowrap;
  }
}
</style>
